import { ValueView, Icon } from "web/components"

export default function EntryUpdated({ event }) {
  const changeDetails = event.change_details

  const settingInitialValue = changeDetails.prev_value === null
  if (settingInitialValue) {
    return (
      <>
        <Icon name="plus-circle" outline="true" />{" "}
        <span>
          {`${event.creator} set`}&nbsp;
          <b>{changeDetails.field_label}</b>&nbsp;{"to"}
        </span>
        <ValueView value={changeDetails.new_value} inert />
      </>
    )
  }

  const deletingValue = changeDetails.new_value === null
  if (deletingValue) {
    return (
      <>
        <Icon name="minus-circle" outline="true" />{" "}
        <span>{`${event.creator} deleted the value`}</span>
        <ValueView value={changeDetails.prev_value} inert />
        <span>
          {"from"}&nbsp;
          <b>{changeDetails.field_label}</b>&nbsp;
        </span>
      </>
    )
  }

  return (
    <>
      <Icon
        name="arrows-right-left"
        outline="true"
        width="20px"
        height="20px"
      />{" "}
      <span>
        {`${event.creator} changed`}
        &nbsp;<b>{changeDetails.field_label}</b>&nbsp;from
      </span>
      <ValueView value={changeDetails.prev_value} inert />
      <span>to</span>
      <ValueView value={changeDetails.new_value} inert />
    </>
  )
}
